module.exports = __webpack_public_path__ + "static/media/logo-sidebar.1af3bde3.svg";